module.exports = __webpack_public_path__ + "img/logo_home.d95b26b8.png";